<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Author Ashlie K. Manger was born and raised in Southern California. Ashlie has a bachelor’s degree from the University of Phoenix and a master’s degree from Southern New Hampshire University. After years of working in a warehouse, Ashlie decided to quit her job and pursue a writing career. As a fan of science fiction and fantasy, Ashlie decided to assemble a collection of short stories to publish as a book. Ashlie’s favorite books are <em>The Great</em> <em>Gatsby</em> by F. Scott Fitzgerald and <em>The Hunger Games</em> by Suzanne Collins. Other favorite authors are Rick Riordan, John Steinbeck, and Shirley Jackson.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?72bf4f7c